import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    LOGIN_USER,
    LOGOUT_USER,
    FORGOT_PASSWORD,
    RESET_PASSWORD,
} from '../actions';

import {
    loginUserSuccess,
    loginUserError,
    forgotPasswordSuccess,
    forgotPasswordError,
    resetPasswordSuccess,
    resetPasswordError,
    setDataUserConcessionaire,
    setTokenExpired,
} from './actions';

import axios from 'axios';
import {
    servicePath,
    urlPhotoProfileDefault,
} from '../../constants/defaultValues';

import rules from '../../config/rules';
import menuItems from '../../constants/menu';

import { navTagInitialStorage } from '../../constants/defaultValues';
import { saveStorage } from '../../helpers/Utils';

export function* watchLoginUser() {
    yield takeEvery(LOGIN_USER, loginWithEmailPassword);
}

const loginWithEmailPasswordAsync = async (email, password) =>
    await axios
        .post(`${servicePath}/users/login/`, {
            email: email,
            password: password,
        })
        .then((res) => res)
        .catch((error) => {
            return error;
        });

function* loginWithEmailPassword({ payload }) {
    const { email, password } = payload.user;
    const { history } = payload;

    try {
        const loginUser = yield call(
            loginWithEmailPasswordAsync,
            email,
            password
        );

        if (loginUser.data) {
            localStorage.setItem(
                'user_name',
                loginUser.data.user.first_name +
                    ' ' +
                    loginUser.data.user.last_name
            );
            localStorage.setItem('user_id', loginUser.data.user.pk);
            localStorage.setItem('token', loginUser.data.token.access);
            localStorage.setItem(
                'picture',
                loginUser.data.user.picture
                    ? loginUser.data.user.picture
                    : urlPhotoProfileDefault
            );
            localStorage.setItem(
                'oldPass',
                loginUser.data.token.password_expired
                    ? loginUser.data.token.password_expired
                    : false
                // true
            );
            localStorage.setItem('role', loginUser.data.user.role[0].data.code);
            localStorage.setItem(
                'productos',
                JSON.stringify(loginUser.data.user.productos)
            );
            localStorage.setItem(
                'rolesList',
                JSON.stringify(loginUser.data.user.role)
            );

            if (loginUser.data.user?.concesionario) {
                const data_producto =
                    loginUser.data.user?.concesionario?.producto;
                const data = [];

                Object.keys(data_producto).forEach((item) => {
                    if (data_producto[item].value !== undefined) {
                        data.push(data_producto[item].value);
                    }
                });

                //localStorage.setItem('producto', data.join(','));
                localStorage.setItem(
                    'concesionario',
                    loginUser.data.user?.concesionario?.pk
                );
            }

            localStorage.setItem('alertPersonalData', true);
            localStorage.setItem(
                'categoria_executive',
                loginUser.data.user?.categoria_ejecutivo?.value
            );

            if (loginUser.data.user?.concesionarios) {
                const data_producto = loginUser.data.user?.concesionarios;

                const data = [];

                Object.keys(data_producto).forEach((item_concesionario) => {
                    var productos = data_producto[item_concesionario]?.producto
                        ? data_producto[item_concesionario]?.producto
                        : [];

                    if (productos) {
                        Object.keys(productos).forEach((item) => {
                            if (productos[item]?.value !== undefined) {
                                data.push(productos[item]?.value);
                            }
                        });
                    }
                });

                let producto_concatenado = data.filter((item, index) => {
                    return data.indexOf(item) === index;
                });

                localStorage.setItem(
                    'IdProductosConConcesionario',
                    producto_concatenado
                );
            }

            yield put(
                setDataUserConcessionaire(
                    loginUser.data.user?.concesionario?.pk
                )
            );

            yield put(
                loginUserSuccess(
                    loginUser.data.user,
                    loginUser.data.token.access,
                    rules[`role_${loginUser.data.user.role[0].data.code}`],
                    menuItems[`role_${localStorage.getItem('role')}`]
                )
            );

            saveStorage(
                navTagInitialStorage,
                rules[`role_${loginUser.data.user.role[0].data.code}`].views
                    .create.components
            );

            history('/');
        } else {
            var error = Object.keys(loginUser.response.data)[0];
            if (loginUser.response?.data?.token?.password_expired === 'True') {
                yield put(loginUserError(''));
                yield put(
                    setTokenExpired({
                        text: loginUser.response.data[error][0],
                        password_expired:
                            loginUser.response?.data?.token?.password_expired,
                    })
                );
            } else {
                yield put(loginUserError(loginUser.response.data[error][0]));
            }
        }
    } catch (error) {
        yield put(loginUserError(error));
    }
}

export function* watchLogoutUser() {
    yield takeEvery(LOGOUT_USER, logout);
}

const logoutAsync = async (history) => {
    // await auth.signOut().then(authUser => authUser).catch(error => error);
    // history('/')
};

function* logout({ payload }) {
    const { history } = payload;
    try {
        yield call(logoutAsync, history);
        localStorage.removeItem('user_name');
        localStorage.removeItem('user_id');
        localStorage.removeItem('role');
        localStorage.removeItem('rolesList');
        localStorage.removeItem('token');
        localStorage.removeItem('picture');
        localStorage.removeItem('producto');
        localStorage.removeItem('oldPass');
        localStorage.removeItem('initialArrTopNavMenu');
        localStorage.removeItem('arrTopNavMenu');
        localStorage.removeItem('concesionario');
        localStorage.removeItem('alertPersonalData');
        localStorage.removeItem('categoria_executive');
    } catch (error) {}
}

export function* watchForgotPassword() {
    yield takeEvery(FORGOT_PASSWORD, forgotPassword);
}

const forgotPasswordAsync = async (email) => {
    return await axios
        .post(`${servicePath}/reset-password/`, { email: email })
        .then((res) => res)
        .catch((error) => {
            const message = error.response?.data?.email;
            return message ? message : 'Correo Invalido';
        });
};

function* forgotPassword({ payload }) {
    const { email } = payload.forgotUserMail;
    try {
        const forgotPasswordStatus = yield call(forgotPasswordAsync, email);
        if (forgotPasswordStatus.data) {
            yield put(forgotPasswordSuccess('success'));
        } else {
            yield put(
                forgotPasswordError(
                    forgotPasswordStatus.message
                        ? forgotPasswordStatus.message
                        : forgotPasswordStatus
                )
            );
        }
    } catch (error) {
        yield put(forgotPasswordError(error));
    }
}

export function* watchResetPassword() {
    yield takeEvery(RESET_PASSWORD, resetPassword);
}

const resetPasswordAsync = async (resetPasswordCode, newPassword) => {
    return await axios
        .post(`${servicePath}/reset-password/verify-token/`, {
            token: resetPasswordCode,
            password: newPassword,
        })
        .then((res) => res)
        .catch((error) => error);
};

function* resetPassword({ payload }) {
    const { newPassword, resetPasswordCode } = payload;
    try {
        const resetPasswordStatus = yield call(
            resetPasswordAsync,
            resetPasswordCode,
            newPassword
        );

        if (resetPasswordStatus.data) {
            yield put(resetPasswordSuccess('success'));
        } else {
            var error = Object.keys(resetPasswordStatus.response.data)[0];
            yield put(
                //resetPasswordError(resetPasswordStatus.response.data[error][0])
                resetPasswordError(resetPasswordStatus.response.data[error])
            );
        }
    } catch (error) {
        yield put(resetPasswordError(error));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchLoginUser),
        fork(watchLogoutUser),
        fork(watchForgotPassword),
        fork(watchResetPassword),
    ]);
}
